<template>
  <div>
    <!--导航栏-->
    <div class="navBar">
      <div class="navInner content">
        <div class="imgBox">
          <img src="../assets/images/logo@2x.png" style="width: 136px" alt="">
        </div>
        <div class="chooseBar">
          <span v-for="(item,index) in navList" :key="index" @click="change(index)" :class="{active:index == choose}">{{item}}</span>
<!--          <span class="cash" @click="download">Download</span>-->
          
        </div>
        <div class="lang-wrap">
          <a href="https://webtrader.wetrade.one" target="_blank" class="sign">{{ signIn }}</a>
          <a href="https://webtrader.wetrade.one" target="_blank" class="sign signup s-act">{{ signUp }}</a>
          <span class="lang">
            <div class="langCon" @click="isShow = !isShow">
              <span class="activ">{{lanText}}</span>
              <img src="../assets/images/down-arrow@2x.png" width="12px" height="12px" alt="">
            </div>
            <div class="lanbox" v-if="isShow">
              <div v-for="(item, index) in language" :key="index" class="lanItem" :class="{checkedLan: item.lan === lanText}"
                @click="changeLang(item.code)"
              >
                <img style="margin-right: 10px;" :src="flagImg(item.code)" width="24px" height="24px" alt="">
                <div style="flex: 1; text-align: left;">
                  {{item.lan}}
                </div>
                <img v-if="item.lan === lanText" src="../assets/images/icon-check@2x.png" width="24px" height="24px" alt="">
              </div>
            </div>
          </span>
        </div>
      </div>
    </div>
    <!--主体-->
    <div>
      <!--Home组件-->
      <Home v-if="choose == '0'" @toMarket="change(1)"></Home>
      <Market v-else-if="choose == '1'"></Market>
      <Platforms v-else-if="choose == '2'"></Platforms>
      <!--FAQ组件-->
      <Faq v-else-if="choose == '3'"></Faq>
      <!--About组件-->
      <About v-else-if="choose == '4'"></About>
    </div>
    <!--页脚-->
    <Footer :home="isHome"></Footer>
    <!--悬浮icon-->
<!--    <div class="client" v-show="client" @click="survey">-->
<!--      <img src="../assets/images/Client.png" alt="">-->
<!--      <div class="icon_close" @click.stop="client = false">-->
<!--        <img src="../assets/images/icon_close.png" alt="">-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
import Home from './Home'
import Faq from './Faq'
import About from './About'
import Market from './Market'
import Platforms from './Platforms'
import Footer from './footerBar'
import * as R from 'ramda'
import config from '../config'
import { jsonp } from '../utils/request'
import { codeList } from '../components/countrycode'

export default {
  components:{
    Home,
    Faq,
    About,
    Footer,
    Market,
    Platforms,
  },
  name: 'index',
  data () {
    return {
      choose: 0,
      isen:null,
      client:true,
      isShow: false,
      isHome: true,
      lanText: this.$t("home_9")
    }
  },
  created(){
    if (localStorage.lang) {
      this.setLan(localStorage.lang)
      return
    }
    jsonp(config.server.api + '/api/user/country/jsonp').then(res => {
      const initLocale = codeList[res.data.toString()] ? codeList[res.data.toString()] : 'en'
      this.setLan(initLocale)
    }).catch(err => {
      const initLocale = "en"
      this.setLan(initLocale)
    })
  },
  computed:{
    navList(){
      return [
        this.$t("home_2"),
        this.$t("home_3"),
        this.$t("home_4"),
        this.$t("home_5"),
        this.$t("home_6"),
      ]
    },
    language(){
      return [
        {code: 'en' , lan: this.$t("home_9")},
        {code: 'hi' , lan: this.$t("home_10")},
        {code: 'vi' , lan: this.$t("home_11")},
        {code: 'zh-TW' , lan: this.$t("home_12")},
        {code: 'ja' , lan: this.$t("home_13")},
        {code: 'th' , lan: this.$t("home_14")},
        {code: 'ph' , lan: this.$t("home_15")},
        {code: 'de' , lan: this.$t("home_16")},
        {code: 'fr' , lan: this.$t("home_17")},
        {code: 'it' , lan: this.$t("home_18")},
        {code: 'es' , lan: this.$t("home_19")},
        {code: 'pt' , lan: this.$t("home_20")},
        {code: 'id' , lan: this.$t("home_21")},
        {code: 'tc' , lan: 'Türkçe'},
        {code: 'ma' , lan: 'Malaysia'},
      ]
    },
    signIn(){
      return this.$t("home_7")
    },
    signUp() {
      return this.$t("home_8")
    },
  },
  methods:{
    setLan(lan) {
      const initLocale = lan
      this.$i18n.locale = initLocale
      this.lanText = this.language[this.filterLanguage(initLocale)].lan
      sessionStorage.index?this.choose=sessionStorage.index:this.choose=0
    },
    change(value){
      this.isHome = (value === 0)
      this.choose = value;
      sessionStorage.index = this.choose
      window.scrollTo(0, 0)
    },
    filterLanguage (locale) {
      return R.findIndex(R.propEq('code', locale))(this.language)
    },
    changeLang(value){
      this.$i18n.locale = value
      localStorage.lang = value
      this.isShow = false
      this.lanText = this.language[this.filterLanguage(value)].lan
      location.reload()
    },
    flagImg (code) {
      return require(`../assets/images/flag/${code}@2x.png`)
    },
    download(){
      // window.open('https://play.google.com/store/apps/details?id=com.happypera.app')
    },
    survey(){
      // window.location.href = 'https://survey.happypera.ph/'
    },
    webPlatform(){
      window.open('https://webtrader.wetrade.one/')
    }
  }
}
</script>

<style scoped lang="scss">
  .navBar{
    height: 60px;
    background: #010012;
    .navInner {
      display: flex;
      justify-content: space-between;
      height: 100%;
    }
    .imgBox{
      margin-top: 15px;
    }
    .chooseBar{
      height: 100%;
      display: flex;
      align-items: center;
      span{
        height: 30px;
        line-height: 30px;
        margin-left: 60px;
        font-size:16px;
        font-family: Helvetica;
        color: #5C6E7B;
        box-sizing: border-box;
        cursor: pointer;
      }
      .active{
        font-family: Roboto-Bold;
        color: #FFFFFF;
        border-bottom: 2px solid #326BFE;
      }
      .cash{
        background-color: rgba(92, 110, 123, 0.19);
        width: 140px;
        height: 32px;
        border-radius: 16px;
        color: #5C6E7B;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      
    }
    .lang-wrap{
      height: 100%;
      display: flex;
      align-items: center;
      color: #FFFFFF;

      a {
        text-decoration: none;
        color: inherit;
      }

      .sign{
        margin-right: 34px;
        font-size: 16px;
        cursor: pointer;
      }
      .s-act{
        height: 34px;
        line-height: 34px;
        background: #FFFFFF;
        border-radius: 17px;
        padding: 0 14px;
        color: #181D24;
      }

      .lang{
        position: relative;
        border-radius: 3px;
        height: 28px;
        display: flex;
        align-items: center;
        z-index: 2;

        .activ {
          margin-right: 5px;
          font-size: 14px;
        }

        .langCon {
          display: flex;
          align-items: center;
          padding: 0 10px;
          height: 100%;
          cursor: pointer;
        }
        span {
          margin-left: 0;
          line-height: 26px;
        }
      }
    }
  }
  .client{
    position: fixed;
    bottom: 5%;
    right: 2%;
    width: 160px;
    height: 160px;
    >img{
      width: 100%;
      height: 100%;
    }
    .icon_close{
      position: absolute;
      top: 5px;
      right: 5px;
      width: 20px;
      height: 20px;
      >img{
        width: 100%;
        height: 100%;
      }
    }
  }

  .lanbox {
    position: absolute;
    right: 0;
    top: 56px;
    //z-index: 1;
    background: #010012;
    border-radius: 6px;
    text-align: center;
    font-size: 14px;
    line-height: 16px;
    min-width: 200px;
    padding: 10px 0;
  }

  .lanItem {
    padding: 8px 20px;
    display: flex;
    align-items: center;
    cursor: pointer;
    &:hover, &.checkedLan {
      background: rgba(24, 29, 36, 0.6);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue